import { Reducer } from "redux";
import { ActionTypes, ILoadingState, LoadingActions } from "./LoadingActionTypes";

export const initialState: ILoadingState = {
    loading: undefined
};

const reducer: Reducer<ILoadingState> = (state: ILoadingState = initialState, action: LoadingActions) => {
    switch (action.type) {
        case ActionTypes.IS_LOADING:
            return { ...state, loading: action.data };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/Loading/LoadingReducer.tsx